import React from 'react';
import Icon from '@/common/components/Icon';
import {
	Description,
	IconBubble,
	Mark,
	Name,
	Row,
	Text,
	Url,
} from '../PageSearch.styles';
import { getHighlightParts } from '../helpers/getSearchItems';

const ResultRow = ({ item, color, tokens, active, onHover, onSelect }) => (
	<Row active={active} onMouseEnter={onHover} onClick={() => onSelect(item)}>
		<IconBubble color={color}>
			{item.path ? (
				<img src={item.path} width={20} height={20} alt={item.name} />
			) : (
				<Icon name={item.icon} size={18} color={color} />
			)}
		</IconBubble>
		<Text>
			<Name>
				{getHighlightParts(item.name, tokens).map((part, index) =>
					part.match ? (
						<Mark key={index}>{part.text}</Mark>
					) : (
						<React.Fragment key={index}>{part.text}</React.Fragment>
					),
				)}
			</Name>
			{item.description && <Description>{item.description}</Description>}
		</Text>
		<Url color={color}>{item.link}</Url>
	</Row>
);

export default ResultRow;
